import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ApiObject, School, Program } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import {
  StudySectionIcon,
  ApplySectionIcon,
  CareerSectionIcon,
  VisaSectionIcon,
  StudentLifeSectionIcon,
  FaqSectionIcon,
  SimilarSchoolSectionIcon,
  CostsSectionIcon,
} from 'assets/explore';
import { newDetailUrl } from 'common/utils/conversions';
import { entityIsProgram, entityIsSchool, navigateTop } from 'common/utils';

interface CompProps {
  entity?: School | Program;
  belongsToProgramSchool?: boolean;
}

interface SectionCardProps {
  title?: string;
  icon?: string;
  entity?: School | Program;
  section_id: string;
}

const SectionCard = ({ title, icon, entity, section_id }: SectionCardProps): React.ReactElement => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (entityIsSchool(entity)) {
      navigate(`${newDetailUrl('schools', entity.id, entity.name)}`);
    } else if (entityIsProgram(entity)) {
      navigate(`${newDetailUrl('programs', entity.id, entity.name)}`);
    }

    setTimeout(() => {
      navigateTop(0, 0, section_id, true, true);
    }, 500);
  };
  return (
    <div className={`card h-100 ${styles.detailSectionCard}`} onClick={() => handleClick()}>
      <Text
        size={16}
        weight={600}
        inlineStyle={{
          color: '#19234F',
        }}
      >
        {title}
      </Text>
      <div className={styles.iconContainer}>
        <img src={icon} className={styles.stepIcon}></img>
      </div>
    </div>
  );
};

export const DetailSections = ({
  entity,
  belongsToProgramSchool,
}: CompProps): React.ReactElement => {
  return (
    <div className={styles.sectionContainer}>
      <h3 className={styles.subtitle} style={{ fontSize: '18px' }}>
        More about this university
      </h3>
      {!belongsToProgramSchool ? (
        <div
          className={`${styles.detailSectionsContainer} row row-cols-1 row-cols-md-2 row-cols-lg-4 mt-4`}
        >
          {entityIsSchool(entity) && (
            <div className={`col ${styles.detailSection}`}>
              <SectionCard
                entity={entity}
                title="Study"
                icon={StudySectionIcon}
                section_id="study"
              />
            </div>
          )}

          {entityIsProgram(entity) && (
            <div className={`col ${styles.detailSection}`}>
              <SectionCard
                entity={entity}
                title="Program profile"
                icon={StudySectionIcon}
                section_id="program-profile"
              />
            </div>
          )}
          <div className={`col ${styles.detailSection}`}>
            <SectionCard entity={entity} title="Apply" icon={ApplySectionIcon} section_id="apply" />
          </div>
          {entityIsProgram(entity) && (
            <div className={`col ${styles.detailSection}`}>
              <SectionCard
                entity={entity}
                title="Fee & cost"
                icon={CostsSectionIcon}
                section_id="fee-costs"
              />
            </div>
          )}
          <div className={`col ${styles.detailSection}`}>
            <SectionCard
              entity={entity}
              title="Career"
              icon={CareerSectionIcon}
              section_id="career"
            />
          </div>
          <div className={`col ${styles.detailSection}`}>
            <SectionCard entity={entity} title="Visa" icon={VisaSectionIcon} section_id="visa" />
          </div>
          <div className={`col ${styles.detailSection}`}>
            <SectionCard
              entity={entity}
              title="Student life"
              icon={StudentLifeSectionIcon}
              section_id="student-life"
            />
          </div>
          <div className={`col ${styles.detailSection}`}>
            <SectionCard entity={entity} title="FAQs" icon={FaqSectionIcon} section_id="faq" />
          </div>
          <div className={`col ${styles.detailSection}`}>
            {entityIsSchool(entity) && (
              <SectionCard
                entity={entity}
                title="Similar university"
                icon={SimilarSchoolSectionIcon}
                section_id="similar-schools"
              />
            )}
          </div>
        </div>
      ) : (
        <div
          className={`${styles.detailSectionsContainer} row row-cols-1 row-cols-md-2 row-cols-lg-4 mt-4`}
        >
          {entityIsSchool(entity) && (
            <div className={`col ${styles.detailSection}`}>
              <SectionCard
                entity={entity}
                title="Study"
                icon={StudySectionIcon}
                section_id="study"
              />
            </div>
          )}
          <div className={`col ${styles.detailSection}`}>
            <SectionCard entity={entity} title="FAQs" icon={FaqSectionIcon} section_id="faq" />
          </div>
          <div className={`col ${styles.detailSection}`}>
            {entityIsSchool(entity) && (
              <SectionCard
                entity={entity}
                title="Similar university"
                icon={SimilarSchoolSectionIcon}
                section_id="similar-schools"
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
